import * as tslib_1 from "tslib";
import { OnInit, } from '@angular/core';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
var LogDetailsModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(LogDetailsModalComponent, _super);
    function LogDetailsModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogDetailsModalComponent.prototype.ngOnInit = function () {
        this.rawMessage = JSON.parse(this.context.data.rawMessage);
    };
    return LogDetailsModalComponent;
}(UiModalComponent));
export { LogDetailsModalComponent };
